import * as betprofessor from './Results.styles.betprofessor';
import * as betroyale from './Results.styles.betroyale';
import * as fiestabet from './Results.styles.fiestabet';
import * as goldenrush from './Results.styles.goldenrush';
import * as juicybet from './Results.styles.juicybet';
import * as puntcity from './Results.styles.puntcity';
import * as puntgenie from './Results.styles.puntgenie';
import * as questbet from './Results.styles.questbet';
import * as sterlingparker from './Results.styles.sterlingparker';
import * as vikingbet from './Results.styles.vikingbet';
import * as volcanobet from './Results.styles.volcanobet';
import * as junglebet from './Results.styles.junglebet';
import * as sugarcastle from './Results.styles.sugarcastle';
import * as oldgill from './Results.styles.oldgill';
import * as buffalobet from './Results.styles.buffalobet';
import * as titanbet from './Results.styles.titanbet';
import * as slambet from './Results.styles.slambet';
import * as gigabet from './Results.styles.gigabet';
import * as betstride from './Results.styles.betstride';
import * as templebet from './Results.styles.templebet';
import * as goldenbet888 from './Results.styles.goldenbet888';
import * as hyperbet from './Results.styles.hyperbet';
import * as bet777 from './Results.styles.bet777';
import * as chromabet from './Results.styles.chromabet';
import * as bet575 from './Results.styles.bet575';
import * as epicodds from './Results.styles.epicodds';
import * as pyramidbet from './Results.styles.pyramidbet';
import * as magnumbet from './Results.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
